import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

import { TEAM_STYLE, categoryLabel } from "./ticketConstants";

/** A ticket's category as a short label from the one label map. "technical"
 *  reads "Technical" with routing off (today) and "Web Dev" with it on. */
export function CategoryBadge({
  category,
  routingEnabled = false,
  className,
}: {
  category: string;
  routingEnabled?: boolean;
  className?: string;
}) {
  return (
    <Badge variant="outline" className={cn(TEAM_STYLE[category], className)}>
      {categoryLabel(category, routingEnabled)}
    </Badge>
  );
}
